import * as moment from "moment";

export class ExternalVendorPackingListReader {

    decoders = {
        M: {
            type: 'MALLINCKRODT NUCLEAR MEDICINE LLC', values: ['rxNum', 'drugCode', 'origQuantity', 'volumeUom',
                'activity', 'activityUom', 'volume', 'calDate', 'calTime', 'expDate', 'expTime']
        },
        I44: {
            type: 'PETNET SOLUTIONS', values: ['CheckDigit', 'drugCode', 'activity', 'ActivityPrecision', 'UnitCode', 'calDate', 'expDate', 'TechIndicator'
                , 'ExpTimeHolder', 'rxNum', 'CalTimeHolder', 'volume', 'VolumePrecision']
        },
        I46:{type:'PETNET SOLUTIONS',values:['CheckDigit','drugCode','activity','ActivityPrecision','UnitCode','calDate','expDate','TechIndicator'
		                                ,'ExpTimeHolder','rxNum','CalTimeHolder','volume','VolumePrecision']
        },
        I57: {
            type: 'PETNET SOLUTIONS', values: ['CheckDigit', 'drugCode', 'activity', 'ActivityPrecision', 'UnitCode', 'calDate', 'expDate', 'TechIndicator'
                , 'ExpTimeHolder', 'rxNum', 'CalTimeHolder', 'volume', 'VolumePrecision', 'rxNum1', 'CalTimeHolder1', 'volume1', 'VolumePrecision1']
        },
        I61: {
            type: 'PETNET SOLUTIONS', values: ['CheckDigit', 'drugCode', 'activity', 'ActivityPrecision', 'UnitCode', 'calDate', 'expDate', 'TechIndicator'
                , 'ExpTimeHolder', 'rxNum', 'CalTimeHolder', 'volume', 'VolumePrecision', 'rxNum1', 'CalTimeHolder1', 'volume1', 'VolumePrecision1']
        },
        I70: {
            type: 'PETNET SOLUTIONS', values: ['CheckDigit', 'drugCode', 'activity', 'ActivityPrecision', 'UnitCode', 'calDate', 'expDate', 'TechIndicator'
                , 'ExpTimeHolder', 'rxNum', 'CalTimeHolder', 'volume', 'VolumePrecision', 'rxNum1',
                'CalTimeHolder1', 'volume1', 'VolumePrecision1', 'rxNum2', 'CalTimeHolder2', 'volume2', 'VolumePrecision2']
        },
        I76: {
            type: 'PETNET SOLUTIONS', values: ['CheckDigit', 'drugCode', 'activity', 'ActivityPrecision', 'UnitCode', 'calDate', 'expDate', 'TechIndicator'
                , 'ExpTimeHolder', 'rxNum', 'CalTimeHolder', 'volume', 'VolumePrecision', 'rxNum1',
                'CalTimeHolder1', 'volume1', 'VolumePrecision1', 'rxNum2', 'CalTimeHolder2', 'volume2', 'VolumePrecision2']
        },
        CAH: { type: 'CARDINAL HEALTH', values: ['checkDigit', 'drugCode', 'unitCode', 'purchCode', 'calDate', 'calibMinutes', 'activity', 
                'volume', 'expDate', 'expMinutes', 'rxNum'] },
        CAH27: { type: 'CARDINAL HEALTH', values: ['plusChar', 'checkDigit', 'drugCode', 'unitCode', 'purchCode', 'calDate', 'calibMinutes', 
                'activity', 'volume', 'expDate', 'expMinutes', 'rxNum'] },
        CAH40:{type:'CARDINAL HEALTH40',values:['drugCode','rxNum','calDays','calTime','activity','volume','expDays','expTime']}
    };

    canDecode(content) {
        let canDecode = false;
        switch(content.length){
            case 26:
            case 27:
            case 40:
            case 44:
            case 46:
            case 50:
            case 57:
            case 61:
            case 70:
            case 76: 
                canDecode = true;
                break;
        }
        return canDecode;
    }

    decode(content) {
        let decodedBarcode;
        switch(content.length){
            case 26:
                decodedBarcode = this.decodeCAHGR(content);
                break;
            case 27:
                decodedBarcode = this.decodeCAH27(content);
                break;
            case 40:
                decodedBarcode = this.decodeCAH40(content);
                break;
            case 50:
                decodedBarcode = this.decodeMallinckrodtGR(content);
                break;
            case 44:
            case 46:
            case 57:
            case 61:
            case 70:
            case 76: 
                decodedBarcode = this.decodeBioDoseGR(content);
                break;
            default:
                decodedBarcode = this.decodeDefault(content);
                break;
        }
        return decodedBarcode;
    }

    // Need to check if we can understand decoding the message. Otherwise, this is of no use.	
    decodeBioDoseGR(content) {
        let pos;
        let decoder;
        switch(content.length) {
            case 44:
                pos = [[0, 1], [2, 5], [5, 9], [9, 10], [11, 12], [14, 18], [18, 22], [22, 23],
                    [23, 25], [31, 37], [37, 39], [39, 43], [43, 44]]
                decoder = this.decoders['I44'];
                break;
            case 46:
                pos=[[0,1],[2,5],[5,9],[9,10],[11,12],[14,18],[18,22],[22,23],
					[23,25],[31,39],[39,41],[41,45],[45,46]]
		        decoder = this.decoders['I46'];
                break;
            case 57:
                pos = [[0, 1], [2, 5], [5, 9], [9, 10], [11, 12], [14, 18], [18, 22], [22, 23],
                    [23, 25], [31, 37], [37, 39], [39, 43], [43, 44], [44, 50], [50, 52], [52, 56], [56, 57]]
                decoder = this.decoders['I57'];
                break;
            case 61:
                pos = [[0, 1], [2, 5], [5, 9], [9, 10], [11, 12], [14, 18], [18, 22], [22, 23],
                    [23, 25], [31, 39], [39, 41], [41, 45], [45, 46], [46, 54], [54, 56], [56, 60], [60, 61]]
                decoder = this.decoders['I61'];
                break;
            case 70:
                pos = [[0, 1], [2, 5], [5, 9], [9, 10], [11, 12], [14, 18], [18, 22], [22, 23], [23, 25],
                    [31, 37], [37, 39], [39, 43], [43, 44], [44, 50], [50, 52], [52, 56],
                    [56, 57], [57, 63], [63, 65], [65, 69], [69, 70]]
                decoder = this.decoders['I70'];
                break;
            case 76:
                pos = [[0, 1], [2, 5], [5, 9], [9, 10], [11, 12], [14, 18], [18, 22], [22, 23], [23, 25],
                    [31, 39], [39, 41], [41, 45], [45, 46], [46, 54], [54, 56], [56, 60],
                    [60, 61], [61, 69], [69, 71], [71, 75], [75, 76]]
                decoder = this.decoders['I76'];
                break;
        }
        return this.decodeIBA(content, decoder, pos);
    }

    decodeIBA(content, decoder, pos) {
        var contentValues = [];
        for (var i = 0; i < (pos.length); i++) {
            contentValues.push(content.substring(pos[i][0], pos[i][1]));
        }
        var decodedOutput = null;
        if (decoder) {
            decodedOutput = { type: decoder.type };
            decoder.values.forEach((value, index) => {
                decodedOutput[value] = contentValues[index];
            });
        }
        return this.decodeDetails(decodedOutput, content);
    }

    calculateQuantity(value, precision) {
        var dividedAmount = Math.pow(10, precision)
        var quantity = value / dividedAmount;
        return quantity
    }

    decodeDetails(decodedOutput, args) {
        var decodeOutput = []
        var id = (args[1] == 'A') ? 1 : 3;
        if (args.length == 44 || args.length == 57 || args.length == 70 || args.length==46  || args.length == 61|| args.length == 76) {   
            var calTime = this.convertJulianDate(decodedOutput.calDate, decodedOutput.CalTimeHolder)
            var expTime = this.convertJulianDate(decodedOutput.expDate, decodedOutput.ExpTimeHolder)
            var activity = this.calculateQuantity(decodedOutput.activity, decodedOutput.ActivityPrecision)
            var volume = this.calculateQuantity(decodedOutput.volume, decodedOutput.VolumePrecision)
            var argument = { type: 'PETNET SOLUTIONS', id: id, calTime: calTime, expTime: expTime, activity: activity, volume: volume, rxNum: decodedOutput.rxNum, drugCode: decodedOutput.drugCode }
            decodeOutput.push(argument)
        }
        if (args.length == 57 || args.length == 70 || args.length == 61|| args.length == 76) { 
            var calTime = this.convertJulianDate(decodedOutput.calDate, decodedOutput.CalTimeHolder1)
            var expTime = this.convertJulianDate(decodedOutput.expDate, decodedOutput.ExpTimeHolder)
            var activity1 = this.calculateQuantity(decodedOutput.activity, decodedOutput.ActivityPrecision)
            var volume1 = this.calculateQuantity(decodedOutput.volume1, decodedOutput.VolumePrecision1)
            var argument2 = { type: 'PETNET SOLUTIONS', id: id, calTime: calTime, expTime: expTime, activity: activity1, volume: volume1, rxNum: decodedOutput.rxNum1, drugCode: decodedOutput.drugCode }
            decodeOutput.push(argument2)
        }
        if (args.length == 70 || args.length == 76) { 
            var calTime = this.convertJulianDate(decodedOutput.calDate, decodedOutput.CalTimeHolder2)
            var expTime = this.convertJulianDate(decodedOutput.expDate, decodedOutput.ExpTimeHolder)
            var activity2 = this.calculateQuantity(decodedOutput.activity, decodedOutput.ActivityPrecision)
            var volume2 = this.calculateQuantity(decodedOutput.volume2, decodedOutput.VolumePrecision2)
            var argument3 = { type: 'PETNET SOLUTIONS', id: id, calTime: calTime, expTime: expTime, activity: activity2, volume: volume2, rxNum: decodedOutput.rxNum2, drugCode: decodedOutput.drugCode }
            decodeOutput.push(argument3);
        }
        return decodeOutput
    }


    convertJulianDate(Value, time) {
        var Date2 = new Date(new Date().getFullYear(), 0, 1);
        var days = (Value.toString().substring(1, 4)) - 1;
        var Date1 = new Date(Date2.setDate(Date2.getDate() + days))
        var calTime = time * .25;
        var calHours = Math.floor(calTime);
        var calMinutes = Math.floor((calTime * 100) - (Math.floor(calTime) * 100)) * 0.6;
        Date1.setHours(calHours); //-1);
        Date1.setMinutes(calMinutes);
        return Date1;
    }

    // Need to check if we can understand decoding the message. Otherwise, this is of no use.
    decodeMallinckrodtGR(content) {
        var positions = [0, 8, 14, 17, 19, 25, 27, 32, 37, 41, 46, 50];
        var contentValues = [];
        for (var i = 0; i < (positions.length - 1); i++) {
            contentValues.push(content.substring(positions[i], positions[i + 1]));
        }
        var decodedOutput = null;
        var decoder = this.decoders['M'];
        if (decoder) {
            decodedOutput = { type: decoder.type };
            decoder.values.forEach((value, index) => {
                decodedOutput[value] = contentValues[index];
            });
        }
        return this.decodeDetailsOfMallin(decodedOutput);
    }

    decodeDetailsOfMallin(output) {
        var mallinOutput = []
        var calTime = this.decodeDate(output.calDate, output.calTime)
        var expTime = this.decodeDate(output.expDate, output.expTime)
        var uom = (output.activityUom == 'MC') ? 2 : (output.activityUom == 'NC') ? 8 : (output.activityUom == 'UC') ? 5 : 0;
        var activityUom = (output.activityUom == 'MC') ? 'mCi' : (output.activityUom == 'NC') ? 'nCi' : (output.activityUom == 'UC') ? 'uCi' : null;
        var volumeUom = output.volumeUom == 'ML' ? 'mL' : null;
        var activity3 = this.calculateQuantity(output.activity, uom);
        var volume3 = this.calculateQuantity(output.volume, 2);
        var decodeOutput = {
            type: 'MALLINCKRODT NUCLEAR MEDICINE LLC', id: 2, rxNum: output.rxNum, drugCode: output.drugCode, origQuantity: output.origQuantity,
            activity: activity3, volume: volume3, calTime: calTime, expTime: expTime, activityUom: activityUom, volumeUom: volumeUom
        }
        mallinOutput.push(decodeOutput)
        return mallinOutput
    }

    decodeDate(calDate, calTime) {
        var finalDate: any;
        var year = (calDate.toString()).substring(0, 2);
        var days = ((calDate.toString()).substring(2, 5)) - 1;
        var correctYear = 20 + year;
        var startDate = new Date(correctYear, 0, 1);
        finalDate = new Date(startDate.setDate(startDate.getDate() + days))
        var hours = (calTime.toString()).substring(0, 2);
        finalDate = moment(finalDate).add(hours, 'hours');
        var minutes = (calTime.toString()).substring(2, 4);
        finalDate = finalDate.add(minutes, 'minutes');
        return new Date(finalDate)
    }

    decodeCAH27(content){
        let split26CharBarcode = content.substring(1,27);
        return this.decodeCAHGR(split26CharBarcode);
    }

    //cah barcode changes 3764 & 3772 start
    decodeCAHGR(content) {
        var positions = [0, 1, 5, 6, 7, 9, 11, 15, 18, 20, 22, 26];
        var contentValues = [];
        for (var i = 0; i < (positions.length - 1); i++) {
            contentValues.push(content.substring(positions[i], positions[i + 1]));
        }
        contentValues.forEach((value, i) => {
            if (!(i === 0 || i === 2 || i === 3)) {
                contentValues[i] = this.decodeBase43(value);
            }
        });
        var decodedOutput = null;
        var decoder = this.decoders['CAH'];
        if (decoder) {
            decodedOutput = { type: decoder.type };
            decoder.values.forEach((value, index) => {
                decodedOutput[value] = contentValues[index];
            });
        }
        return this.decodeDetailsOfCAH(decodedOutput);
    }

    decodeCAH40(content) {
		var positions = [0,4,11,14,18,25,32,36,40];
		var contentValues = [];
		for(var i=0;i<(positions.length-1);i++){
			contentValues.push(content.substring(positions[i],positions[i+1]));
		}
		var decodedOutput = null;
		var decoder = this.decoders['CAH40'];
		if (decoder) {
			decodedOutput = {type:decoder.type};
			decoder.values.forEach(function(value,index) {
				decodedOutput[value] = contentValues[index];
			});
		}
		return this.decodeDetailsOfCAH40(decodedOutput);
	}

    decodeDetailsOfCAH40 (output){
		var cahOutput =  [];
		var divisorActivity = 100;
		var divisorVolume = 100;
		var calibrationDays = parseInt(output.calDays) - 1;
		var expirationDays = calibrationDays + parseInt(output.expDays);
		var calTime = this.convertJulianDateforCAH40(calibrationDays,output.calTime);
		var expTime = this.convertJulianDateforCAH40(expirationDays,output.expTime);
		var activity = (output.activity/divisorActivity);
		var volume = (output.volume/divisorVolume);
		var decodeOutput = {type:'CARDINAL HEALTH40',id:5,drugCode:output.drugCode.substring(0,4),rxNum:output.rxNum,calTime:calTime,activity:activity,volume:volume,expTime:expTime};
		cahOutput.push(decodeOutput);
		return cahOutput;
	}

    convertJulianDateforCAH40(days,time){
		var startDate = new Date(new Date().getFullYear(),0,1);
		var finalDate = new Date(startDate.setDate(startDate.getDate() + days));
		var hours = (time.toString()).substring(0,2);
		var minutes = (time.toString()).substring(2,4);
		finalDate.setHours(hours,minutes);
		return new Date(finalDate);
	} 

    decodeBase43(src) {
        let cSense: any;
        var srcAlphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%";
        var dstAlphabet = "0123456789";
        var caseSensitive = false;
        if (srcAlphabet == srcAlphabet.toLowerCase() || srcAlphabet == srcAlphabet.toUpperCase()) {
            cSense = caseSensitive;
        } else {
            cSense = true;
        }
        var srcBase = srcAlphabet.length;
        var dstBase = dstAlphabet.length;
        var wet = src;
        var val = 0;
        var mlt = 1;
        while (wet.length > 0) {
            var digit = wet.charAt(wet.length - 1);
            var digVal = srcAlphabet.indexOf(digit);
            if (!cSense) {
                if (digVal == -1) {
                    digVal = srcAlphabet.indexOf(digit.toLowerCase());
                }
                if (digVal == -1) {
                    digVal = srcAlphabet.indexOf(digit.toUpperCase());
                }
            }
            if (digVal > -1) {
                val += mlt * digVal;
                mlt *= srcBase;
            }
            wet = wet.substring(0, wet.length - 1);
        }
        wet = val;
        var ret = "";
        while (wet >= dstBase) {
            var digitVal = wet % dstBase;
            var digit: any = dstAlphabet.charAt(digitVal);
            ret = digit + ret;
            wet /= dstBase;
        }
        var digit: any = dstAlphabet.charAt(wet);
        ret = digit + ret;
        return ret;
    }

    decodeDetailsOfCAH(output) {
        var cahOutput = [];
        var divisorActivity = 1000;
        var divisorVolume = 100;
        var calTime = this.calculateCalibrationDate(new Date(), output.calDate, output.calibMinutes);
        var expTime = this.calculateExpirationDate(output.expDate, output.expMinutes, calTime);
        var activity = (output.activity / divisorActivity);
        var volume = (output.volume / divisorVolume);
        var drugCode = output.drugCode.substring(0, 4) + '-' + output.purchCode + '-' + this.decodeUnitCode(output.unitCode);
        var decodeOutput = {
            type: 'CARDINAL HEALTH', id: 4, checkDigit: output.checkDigit, drugCode: drugCode, unitCode: this.decodeUnitCode(output.unitCode),
            purchCode: output.purchCode, calTime: calTime, activity: activity, volume: volume, expTime: expTime, rxNum: output.rxNum
        };
        cahOutput.push(decodeOutput);
        return cahOutput;
    }

    decodeUnitCode(unitCode) {
        var cahUnitCode: any = '';
        if (unitCode && typeof unitCode == 'string') {
            switch (unitCode.toUpperCase()) {
                case 'U': 
                    cahUnitCode = '1';
                    break;
                case 'M': 
                    cahUnitCode = '2';
                    break;
                case 'C': 
                    cahUnitCode = '3';
                    break;
                default: 
                    cahUnitCode = '';
                    break;
            }
        } else if (unitCode != '' && unitCode != null) {
            cahUnitCode = parseInt(unitCode);
        } else {
            cahUnitCode = null;
        }
        return cahUnitCode;
    }

    calculateCalibrationDate(processDate, CalibDays, CalibMinutes) {
        var rightBuffer = 365;
        var leftBuffer = (365 * 4);
        var baseDate: any = this.getBaseDate(processDate);
        var diffTime = Math.abs(processDate - baseDate);
        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays < rightBuffer && CalibDays > leftBuffer) {
            baseDate.setFullYear(baseDate.getFullYear() - 5);
        } else if (diffDays > leftBuffer && CalibDays < rightBuffer) {
            baseDate = baseDate.AddYears(5);
            baseDate.setFullYear(baseDate.getFullYear() + 5);
        }

        return this.calcDateTimeFromUDM(CalibDays, CalibMinutes, baseDate);
    }

    getBaseDate(date) {
        var year = date.getFullYear();
        var yearDifference = ((year - 4) % 5);
        if (yearDifference == 0 && date.getMonth() == 1 && date.getDate() <= 15) {
            yearDifference += 5;
        }
        var baseDateYear = (year - yearDifference);
        return new Date(baseDateYear, 0, 1); //cah barcode changes
    }

    calcDateTimeFromUDM(days, time, processDate) {
        time = time * 5;
        if (time >= 2400) { time = 2359; }
        var hours = Math.floor(time / 100);
        var minutes = time - (hours * 100);
        var date = moment(processDate).add(days, 'd').add(hours, 'h').add(minutes, 'm').add(0, 's');
        return date.toDate();
    }

    calculateExpirationDate(expDays, expMinutes, calibrationDate) {
        var baseCalDate = new Date(calibrationDate);
        baseCalDate.setHours(0, 0, 0, 0);
        return this.calcDateTimeFromUDM(expDays, expMinutes, baseCalDate);
    }

    //cah barcode changes 3764 & 3772 end
    decodeDefault(content) {
        return { type: "Unknown", barcode: content };
    }
}